<template>
  <div class="upgrade-modal">
    <img class="callout m-b-10" src="/facetime-meeting-alt.svg">
    <h3 class="title is-3 is-spaced">{{ title }}</h3>
    <p class="subtitle is-5 m-b-20">{{ subtitle }}</p>
    <button @click="startUpgrade()" class="button is-primary is-medium is-fullwidth m-t-30">Upgrade account</button>
  </div>
</template>
<script>
import UpgradeAccount from '~/components/modals/UpgradeAccount'

export default {
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: true
    },
    // eslint-disable-next-line vue/prop-name-casing
    from_location: {
      type: String,
      required: false,
      default: undefined
    },
    // eslint-disable-next-line vue/prop-name-casing
    button_text: {
      type: String,
      required: false,
      default: undefined
    }
  },
  methods: {
    startUpgrade () {
      this.$buefy.modal.open({
        parent: this,
        fullScreen: true,
        component: UpgradeAccount,
        canCancel: false,
        customClass: 'upgrade-modal',
        props: {
          from_location: this.from_location,
          button_text: this.button_text
        },
        trapFocus: true
      })
      this.$nextTick(() => {
        this.$parent.close()
      })
    }
  }
}
</script>

<style scoped lang="scss">
.upgrade-modal {
  img {
    width: 180px
  }
}
</style>
